<template>
  <div class="rs-filter-cat">
    <button
      id="filterToggle"
      class="rs-filter-cat__btn"
      :class="{ 'rs-filter-cat__btn--active': isToggled }"
      @click.prevent="toggle"
    >
      <RsIcon icon="far fa-sliders-h" />
    </button>
    <div
      class="rs-filter-cat__content"
      :class="{ toggled: isToggled }"
    >
      <RsChip
        v-for="(item, i) in items"
        :id="item.id"
        :key="i"
        variant="light"
        :class="{ active: item.active }"
      >
        {{ item.title }}
      </RsChip>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

export type TFilterCatItems = {
  id: string,
  active: boolean,
  title: string,
};

export default defineComponent({
  name: 'RsFilterCat',

  props: {
    /**
      * title | active
    */
    items: {
      type: Array as PropType<TFilterCatItems[]>,
    },

  },
  data() {
    return {
      isToggled: false,
    };
  },
  methods: {
    toggle() {
      this.isToggled = !this.isToggled;
    },
  },
});
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.rs-filter-cat{
  display: flex;
  align-items: center;
  &__btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    color: $form-label-color;
    font-size: 18px;
    border-radius: 50%;
    transition: all 0.3s ease;
    &--active{
      opacity: 1;
      transform: rotate(90deg);
      background-color: lighten($primary-color, 50%);
    }
  }
  &__content{
    margin-left: 1rem;
    display: none;
    p{
      margin: 0;
    }
    .rs-chip{
      margin-right: 1rem;
      transition: all 0.25s ease;
      &:last-child{
        margin-right: 0;
      }
      &:hover{
        cursor: pointer;
        background-color: $primary-color !important;
        span{
          transition: all 0.25s ease;
          color: $white;
        }
      }
      &.active{
        background-color: $primary-color;
        span{
          color: $white;
        }
      }
    }
    &.toggled{
      display: flex;
      animation: fadeInLeft .3s;
    }
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
